<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h3>This form is closed.</h3>
</div>
